const CAROUSEL_ITEMS = [
  {
    title: '夏日恋爱特辑',
    desc: '精选20部高甜恋爱漫画，从校园到职场，从韩漫到日漫，承包你的夏日心动。',
    img: 'https://readdy.ai/api/search-image?query=Summer%20romance%20manga%20feature%20banner%20with%20beach%20sunset%20and%20couple%20silhouette%2C%20warm%20golden%20and%20pink%20tones%2C%20romantic%20atmosphere%2C%20Korean%20webtoon%20aesthetic%2C%20clean%20cinematic%20wide%20composition&width=1000&height=500&seq=carousel-01&orientation=landscape',
    tag: '本期专题',
    color: 'from-pink-500/60 to-orange-500/40',
  },
  {
    title: '国漫崛起计划',
    desc: '支持国产漫画，发现新一代国漫创作者。精选50部高分国漫作品，见证中国漫画力量。',
    img: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20manhua%20showcase%20banner%20with%20traditional%20and%20modern%20elements%2C%20mountain%20landscape%20with%20martial%20arts%20characters%2C%20warm%20red%20and%20gold%20tones%2C%20grand%20cinematic%20atmosphere&width=1000&height=500&seq=carousel-02&orientation=landscape',
    tag: '特别策划',
    color: 'from-red-500/60 to-amber-500/40',
  },
  {
    title: '韩漫人气TOP100',
    desc: '综合阅读量、收藏数、读者评分，精选百部最受欢迎韩漫作品，口碑之作一网打尽。',
    img: 'https://readdy.ai/api/search-image?query=Popular%20Korean%20webtoon%20ranking%20banner%20with%20colorful%20manga%20covers%20collage%2C%20vibrant%20modern%20design%2C%20warm%20coral%20and%20cream%20tones%2C%20exciting%20promotional%20atmosphere&width=1000&height=500&seq=carousel-03&orientation=landscape',
    tag: '排行榜',
    color: 'from-purple-500/60 to-pink-500/40',
  },
  {
    title: '悬疑推理之夜',
    desc: '每月精选高智商烧脑漫画，从日式本格推理到韩式悬疑惊悚，挑战你的推理极限。',
    img: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20manga%20feature%20banner%20with%20dark%20moody%20atmosphere%2C%20rainy%20city%20alleyway%2C%20detective%20theme%2C%20cool%20blue%20and%20teal%20tones%2C%20suspenseful%20cinematic%20composition&width=1000&height=500&seq=carousel-04&orientation=landscape',
    tag: '每月精选',
    color: 'from-blue-500/60 to-indigo-500/40',
  },
  {
    title: '奇幻世界漫游指南',
    desc: '带你穿越异世界！精选异世界转生、奇幻冒险、魔法学院等热门题材，开启奇妙阅读之旅。',
    img: 'https://readdy.ai/api/search-image?query=Fantasy%20world%20manga%20feature%20banner%20with%20magical%20landscape%2C%20floating%20islands%20and%20dragons%2C%20vibrant%20purple%20and%20gold%20sky%2C%20adventure%20atmosphere%2C%20epic%20cinematic%20wide%20composition&width=1000&height=500&seq=carousel-05&orientation=landscape',
    tag: '主题推荐',
    color: 'from-teal-500/60 to-cyan-500/40',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            焦点专题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            编辑精选<strong>好看的漫画</strong>专题，发现更多精彩<strong>免费漫画</strong>内容
          </p>
        </div>
        <div className="flex flex-col gap-4 md:gap-5">
          {CAROUSEL_ITEMS.map((item, idx) => (
            <a
              key={idx}
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group relative w-full rounded-2xl overflow-hidden h-[200px] md:h-[280px] bg-background-200 cursor-pointer"
            >
              <img
                src={item.img}
                alt={`虫虫漫画网专题 - ${item.title}`}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                loading="lazy"
              />
              <div className={`absolute inset-0 bg-gradient-to-r ${item.color}`}></div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-8">
                <span className="inline-block px-3 py-1 text-xs font-semibold bg-background-50/90 text-foreground-800 rounded-full mb-3">
                  {item.tag}
                </span>
                <h3 className="text-xl md:text-2xl font-bold text-background-50 font-heading mb-2">
                  {item.title}
                </h3>
                <p className="text-sm md:text-base text-background-200 max-w-2xl line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}